import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "product-remember-list" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Bestillingsliste", -1)
const _hoisted_4 = { class: "messages" }
const _hoisted_5 = { class: "add-product" }
const _hoisted_6 = { class: "add-product-fields" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Legg til produkt", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "remember-table-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "remember-table"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Varenavn", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "mobile-product-number"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "sim-modal" }
const _hoisted_19 = { class: "sim-input" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Strekkode", -1)
const _hoisted_21 = { class: "sim-actions" }
const _hoisted_22 = { class: "empty-modal" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Er du sikker?", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Dette vil fjerne alle produkter fra huskelisten.", -1)
const _hoisted_25 = { class: "empty-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Messages = _resolveComponent("Messages")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_ProductSelect = _resolveComponent("ProductSelect")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.developer)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.barcodeSimOpen = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Simuler scan")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.admin)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            color: "red",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emptyListOpen = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tøm listen")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Messages)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ValidationFormErrors, {
        errors: _ctx.form.errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _hoisted_7,
          _createVNode(_component_ProductSelect, {
            modelValue: _ctx.form.product_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.product_id) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_Button, {
          color: "green",
          onClick: _ctx.addProduct
        }, {
          default: _withCtx(() => [
            _createTextVNode("Legg til")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.remembers?.length && _ctx.remembers.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Scan produkter for å legge til. "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.remembers?.length && _ctx.remembers.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_ctx.windowsSize !== 'sm')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Varenummer"))
                  : _createCommentVNode("", true),
                _hoisted_12,
                _hoisted_13
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remembers, (remember) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: remember.id
                }, [
                  (_ctx.windowsSize !== 'sm')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(remember.product_id), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      class: "product-link",
                      href: _ctx.route('products.show', { product: remember.product_id }),
                      target: "_blank"
                    }, _toDisplayString(remember.product.name), 9, _hoisted_15),
                    (_ctx.windowsSize === 'sm')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(remember.product_id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_Button, {
                      onClick: ($event: any) => (_ctx.removeProduct(remember.product_id)),
                      color: "red",
                      disabled: _ctx.removeProductLoading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Fjern")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_17, " Ingen produkter i huskelisten. Scan produkter for å legge til. "))
    ]),
    (_ctx.barcodeSimOpen)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.barcodeSim) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.barcodeSim]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.barcodeSimOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lukk")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "green",
                  onClick: _ctx.simScan
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Scan")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.emptyListOpen)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_Button, {
                  color: "red",
                  onClick: _ctx.emptyList,
                  disabled: _ctx.emptyListLoading
                }, {
                  default: _withCtx(() => [
                    (_ctx.emptyListLoading)
                      ? (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 0,
                          class: "loading animate-spin",
                          type: "mdi",
                          path: _ctx.mdiLoading
                        }, null, 8, ["path"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Fjern alle produkter ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emptyListOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}